import {
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';
import cgu from '../../../pdf/CGU.pdf';
import confidentialite from '../../../pdf/politique.pdf';
import AccountCreation from './AccountCreation';

const RegisterEmail = (
  { user },
  ref,
) => {
  const [email, setEmail] = useState('');
  const [pw1, setPw1] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [createaccountLoading, setCreateaccountLoading] = useState(false);

  useImperativeHandle(ref, () => ({}));

  const onblurScrolltoTop = () => {
    window.scrollTo(0, 0);
    if (document.getElementById('page_register')) {
      document.getElementById('page_register').scrollTop = 0;
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="w-full h-full createaccount">
        <AccountCreation
          email={email}
          setEmail={setEmail}
          showPassword={showPassword}
          onblurScrolltoTop={onblurScrolltoTop}
          handleTogglePasswordVisibility={handleTogglePasswordVisibility}
          password1={pw1}
          setPassword1={setPw1}
          createAccountLoading={createaccountLoading}
          setCreateaccountLoading={setCreateaccountLoading}
          user={user}
        />

        <div
          style={{ fontFamily: 'Open Sans', fontWeight: 400 }}
          className="top-12 text-center relative"
        >
          <span>En créant un compte j'accepte</span>
          <a href={cgu} target="_blank" rel="noreferrer">
            {' '}
            Conditions Générales d'Utilisation{' '}
          </a>{' '}
          et la{' '}
          <a href={confidentialite} target="_blank" rel="noreferrer">
            politique de confidentialité
          </a>{' '}
          de PikkoPay
        </div>
      </div>
    </>
  );
};

export default forwardRef(RegisterEmail);

